import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core';

const loadOptions = async () => {
  const zxcvbnCommonPackage = await import(
    /* webpackChunkName: "zxcvbnCommonPackage" */ '@zxcvbn-ts/language-common'
  );

  const zxcvbnEnPackage = await import(
    /* webpackChunkName: "zxcvbnEnPackage" */ '@zxcvbn-ts/language-en'
  );

  return {
    dictionary: {
      ...zxcvbnCommonPackage.dictionary,
      ...zxcvbnEnPackage.dictionary,
    },
    graphs: zxcvbnCommonPackage.adjacencyGraphs,
    translations: zxcvbnEnPackage.translations,
  };
};

async function Strength(password?: string) {
  try {
    const options = await loadOptions();
    zxcvbnOptions.setOptions(options);

    return zxcvbn(password || '');
  } catch (e) {
    return { score: 0 };
  }
}

export default Strength;